import { render } from "./Loader.vue?vue&type=template&id=f707e202"
const script = {}

const cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=f707e202&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__